/* elu-newsletter.js — runda 5 R5.2 (planuri\runda5.md): completează popup-ul de newsletter Kalles (sections/newsletter-modal.liquid).
   1. După abonare (din subsol sau din popup) popup-ul nu mai apare: cookie-ul Kalles „theme4:newsletter:<id>” = shown pe 365 de zile.
   2. Răspunsul formularului din popup (succes / eroare) se vede: după reîncărcare, popup-ul se deschide dacă a fost trimis din el.
   3. Intenția de ieșire pe desktop (≥ 1025 px): mouse-ul iese prin partea de sus → popup-ul se deschide o dată (dacă nu e deja închis / abonat). */
(() => {
  if (window.__eluNewsletterBound) return;
  window.__eluNewsletterBound = true;
  const sys = document.querySelector('sys-newsletter');
  if (!sys) return;
  let id = '';
  try { id = JSON.parse(sys.getAttribute('configs')).id; } catch (e) { return; }
  const KEY = 'theme4:newsletter:' + id;
  const MARK = 'elu_nl_din_popup';
  const areCookie = () => document.cookie.split('; ').some(c => c === KEY + '=shown');
  const puneCookie = zile => { document.cookie = `${KEY}=shown; max-age=${zile * 86400}; path=/; SameSite=Lax`; };
  const modal = sys.querySelector('hdt-modal');
  const deschide = () => { try { modal && modal.open(); } catch (e) {} };

  document.addEventListener('submit', e => {
    const f = e.target;
    if (!f.querySelector || !f.querySelector('input[name="contact[tags]"][value="newsletter"]')) return;
    puneCookie(365);
    if (modal && !sys.contains(f)) modal.open = () => {};   // temporizatorul Kalles (pornit la încărcare) nu mai deschide popup-ul după abonarea din subsol
    try { sessionStorage.setItem(MARK, sys.contains(f) ? '1' : '0'); } catch (err) {}
  }, true);

  let dinPopup = null;
  try { dinPopup = sessionStorage.getItem(MARK); sessionStorage.removeItem(MARK); } catch (err) {}
  if (dinPopup === '1' && sys.querySelector('.hdt-newsletter__success, .hdt-newsletter__error')) {
    if (document.readyState === 'complete') deschide(); else window.addEventListener('load', deschide, { once: true });
    return;
  }

  if (window.matchMedia('(min-width: 1025px)').matches) {
    const iesire = e => {
      if (e.clientY > 0 || e.relatedTarget) return;
      document.documentElement.removeEventListener('mouseleave', iesire);
      if (!areCookie()) deschide();
    };
    document.documentElement.addEventListener('mouseleave', iesire);
  }
})();
